import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import PropTypes from 'prop-types';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import {numberOnly} from '../../../server/util.js'
import {_addNotification, _addNotificationError} from '../../../server/util';
import {isValidForm} from '../../../server/validationMethods.js'
import {postWithHeaders} from "../../../server/actionsParent";
import Draft from './draft.js';
import Promise from 'promise';
import moment from 'moment';
class SSN extends Component {
    constructor(props){
        super(props)
        this.validateLength=this.validateLength.bind(this);
        this.validateSSN=this.validateSSN.bind(this);
        this.isValidated=this.isValidated.bind(this);
    }
    validateLength=(value)=>{
        if (value  !==undefined  && value !== null && value !== '' && !(value.length===4)) {
            return <span className="text-danger"><Trans>Please enter last 4 digits of the Socila Security Number</Trans>.</span>
          }
    }
    validateSSN=(value)=>{
        if (this.props.lunchObj.persons[0].noSSN===true) {
            return;
        }
        if (value === undefined || value === null || value.toString().trim() === '') {
            return <span className="text-danger"><Trans>Please enter SSN or select ‘No SSN’ to continue.</Trans>.</span>
        }
    }
    isValidated=()=>{
          
    }
    
    render(){
        return(<div>
            <div className="form-row">
                <div className="col-md-12 form-group" style={{marginBottom:'0px'}}>
                    <p><Trans>Please provide the last four digits of the Social Security number for the person that signed at the beginning of the application</Trans>.</p>
                </div>
            </div>
            <div className="row">   
            <Form ref={(f)=>this.frmSSN=f}>                  
            <div className="form-row">
                <div className="col-md-5 form-group">
                    <Input type="text" name="ssn" className="form-control text-right"
                     value={this.props.lunchObj.persons[0].ssn} minLength="4" maxLength="4"
                      placeHolder={'XXXX'} validations={[this.validateSSN, this.validateLength]} readOnly={this.props.lunchObj.persons[0].noSSN===true}
                onKeyPress={numberOnly} onChange={(e)=>{
                    this.props.onSSNChange(e.target.name,e.target.value)
                }} /> 
                </div>
            </div>
            <div className="form-row">
                <div className="col-md-5">
                <div className="styled-input-container styled-input--square">
                    <div className="styled-input-single" style={{padding:'1px 0px 5px 40px'}}>
                <input type="checkbox" id="noSSN" name="noSSN" 
                    checked={this.props.lunchObj.persons[0].noSSN===true}  
                    onChange={(e)=>{            
                        this.props.onNoSSNChange('noSSN',e.target.checked?true:false)
                    }} /> <label htmlFor="noSSN"><Trans>No SSN</Trans></label>
                    </div></div>
                </div>
            </div>
            </Form>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(13);
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{ 
                        if(this.props.lunchObj.persons[0].noSSN===true){
                            this.props.jumpToStep(15)
                        }else{
                            this.frmSSN.validateAll();
                            if(!isValidForm(this.frmSSN)){
                                return false;
                            }else{                            
                                this.props.jumpToStep(15);   
                            }
                        }
                    }}>
                        <Trans>Continue</Trans>
                    </button>
                    <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo} isDistrict={this.props.isDistrict} />
                </div>
          </div>
        </div>)
    }
}
export default SSN


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/ssn.jsx